import ListsEvent from '@/domain/events/index';
import { getArchivedEvents } from '@/infra/events/eventRepository';

export async function getArchivedEventsAll(): Promise<ResolvedEventData> {
  try {
    const res = await getArchivedEvents();
    const events = res?.events?.map((e: any) => new ListsEvent(e));
    return { items: events };
  } catch (error: any) {
    if (error.message === 'ServerError') {
      throw error;
    }
    throw error;
  }
}

export default getArchivedEventsAll;

export type ResolvedEventData = { items: ListsEvent[] };
